import { useCallback, useEffect } from "react";
import { useBoolean } from "@chakra-ui/react";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        Cookiebot?: {
            consent: {
                statistics: boolean;
            };
        };
    }
}

const hideCookieBotConsentUnderlay = () => {
    const underlay = document.getElementById("CybotCookiebotDialogBodyUnderlay");
    if (underlay) {
        underlay.style.display = "none";
    }
};

const COOKIEBOT_LOADED_CHECK_TIMEOUT = 4000;

export function useCookieBotConsentReady() {
    const [isConsentReady, setIsConsentReady] = useBoolean(false);
    const handleCookieBotConsentReady = useCallback(() => {
        setIsConsentReady.on();
        hideCookieBotConsentUnderlay();
    }, [setIsConsentReady]);

    useEffect(() => {
        setTimeout(() => {
            if (!document.getElementById("Cookiebot") && !window.Cookiebot) {
                handleCookieBotConsentReady();
            }
        }, COOKIEBOT_LOADED_CHECK_TIMEOUT);

        window.addEventListener("CookiebotOnConsentReady", handleCookieBotConsentReady, false);

        return () => {
            window.removeEventListener("CookiebotOnConsentReady", handleCookieBotConsentReady);
        };
    }, [handleCookieBotConsentReady]);

    return isConsentReady;
}
